module.exports = __webpack_public_path__ + "static/img/logistics-h5-2.eb76700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logistics-h5-2.png
// module id = iQCu
// module chunks = 34